import React from "react";
import "../components/CookieConsent/CookieConsent.css";

export default function UserFooter() {
  return (
    <>
      <footer className="main-footer d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div>
          <strong>
            Copyright &copy; 2014-2023{" "}
            <a href="https://indsac.com">CRM-Dashboard</a>.
          </strong>{" "}
          All rights reserved.
        </div>
        <div className="d-flex align-items-center gap-3">
          <button
            type="button"
            className="cookie-footer-link text-muted small"
            style={{ fontSize: "0.85rem" }}
            onClick={() => {
              if (typeof window.openCookiePreferences === "function") {
                window.openCookiePreferences();
              }
            }}
          >
            Cookie Settings
          </button>
          <span className="d-none d-sm-inline text-muted small">Anything you want</span>
        </div>
      </footer>
    </>
  );
}
